import {SxProps, Theme} from '@mui/material';

const Container: SxProps<Theme> = {
	display: 'flex',
	width: '100%',
	backgroundColor: 'grey.100',
	borderRadius: '12px',
	padding: '4px',
	gap: '4px',
};

const Tab = (isActive: boolean): SxProps<Theme> => ({
	flex: 1,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '6px',
	padding: '10px 16px',
	borderRadius: '8px',
	minHeight: '40px',
	transition: 'background-color 0.2s ease',
	backgroundColor: isActive ? 'background.paper' : 'transparent',
	'&:hover:not(:disabled)': {
		backgroundColor: isActive ? 'background.paper' : 'action.hover',
	},
});

export {Container, Tab};
